module.exports = __webpack_public_path__ + "img/column_202510.760eb30e.png";